import ajax from "@/libs/Ajax";

let NAME_SPACE = "/aseapi/console";

export default {
    initList() {
        return ajax.get(`${NAME_SPACE}/common/initList`);
    },
    listConnType() {
        return ajax.get(`${NAME_SPACE}/common/listConnType`)
    },
    getJsonMould(uuid) {
        return ajax.get(`${NAME_SPACE}/sysmgr/mouldmgr/getJsonMould`, {params: {uuid: uuid}})
    },
};
